import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { PlaneRoutePage } from "../app/planeRoute";

export const Route = createFileRoute("/facts")({
  component: FactsRoute,
});

function FactsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <PlaneRoutePage kindId="facts" search={search} />;
}
